import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'decimal',
})
export class DecimalPlacesPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: any, transform = true) {
    if (!transform || isNaN(value)) {
      return value;
    }

    value = +value;
    let digitsInfo = '1.3-3';

    if (value >= 100) {
      digitsInfo = '1.0-0';
    } else if (value >= 10 && value < 100) {
      digitsInfo = '1.1-1';
    } else if (value >= 1 && value < 10) {
      digitsInfo = '1.2-2';
    }

    const decimalPipe = new DecimalPipe(this.translate.currentLang);
    return decimalPipe.transform(value, digitsInfo);
  }
}
